const calculateProgress = (raised:number, total:number) => {
    const perc = Math.round( ( raised / total ) * 100);
    if(perc > 100){
        return 100;
    }else{
        return perc;
    }
};


export {
    calculateProgress
  }